<template>
  <ProSpaceGeoLayout>
    <template #top>
      <ProSpaceFilterPanel
        :modelFastFilter="modelFastFilter"
        :fastFilters="fastFilters"
        :searchPlaceholder="$t('searchTxt')"
        :unicKeyStorage="roleService.constructor.name + 'grid'"
        @apply="submitFilter"
        ref="filter-panel"
        filter-model="firstName"
      >
        <template #hint> {{ $t("filterBy") }}</template>
        <template #filters="{ filter }">
          <ProSpaceMultiSelect
            :localization="$t"
            v-model="filter.status"
            :service="statusService"
            getMethod="get"
            optionLabel="text"
            optionValue="status"
            :selectAllTxt="$t('selectAllTxt')"
            :closeTxt="$t('closeTxt')"
            :placeholderValue="$t('status')"
            :applyTxt="$t('applyTxt')"
            :clearFilterTxt="$t('clearTxt')"
            :searchPlaceholder="$t('searchTxt')"
            @apply="emitFilter"
          />
          <ProSpaceCustomFilterPanel
            :customTxt="$t('custom')"
            :customFilterTxt="$t('customFilterTxt')"
            :clearFilterTxt="$t('clearTxt')"
            :selectAllTxt="$t('selectAllTxt')"
            :closeTxt="$t('closeTxt')"
            :applyTxt="$t('applyTxt')"
            :fromTxt="$t('fromTxt')"
            :toTxt="$t('toTxt')"
            :services="customServices"
            :unicKeyStorage="roleService.constructor.name + 'grid'"
            @apply="(model) => customFilterApply(filter, model)"
          />
        </template>
      </ProSpaceFilterPanel>
    </template>
    <template #center>
      <ProSpaceMainGrid
        ref="grid"
        :service="roleService"
        @selected-change="selectedHandler"
        :noMountedRequest="true"
        getMethod="grid"
        selectionMode="multiple"
      >
        <template #columns>
          <Column field="name" header="Name" sortable>
            <template #body="field">
              <ProSpaceTableHeaderCell
                :id="field.data.id"
                :status="getStatus(field.data.status)"
                :title="field.data.systemName"
                :description="`${field.data.description || ''}`"
              />
            </template>
          </Column>
        </template>
        <template #empty>
          <ProSpaceEmptyGrid
            icon="error-message"
            :title="$t('noDataTitle')"
            :text="$t('noDataTxt')"
          />
        </template>
      </ProSpaceMainGrid>
    </template>
    <template #right>
      <NotificationRolesPanel
        v-if="selectedModel.length > 0"
        :service="roleService"
        :ids="selectedModel"
      />
    </template>
  </ProSpaceGeoLayout>
</template>
<script>
import {
  ProSpaceTableHeaderCell,
  ProSpaceCustomFilterPanel,
  ProSpaceMultiSelect,
  ProSpaceFilterPanel,
  ProSpaceInputText,
  ProSpaceGeoLayout,
  ModalForm,
  event_bus,
  ProSpaceMainGrid,
  ProSpaceEmptyGrid,
} from "@prospace/prospace-components-library";
import Column from "primevue/column";

import { RoleService } from "../../services/RoleService.js";
import { StatusService } from "../../services/StatusService.js";
import NotificationRolesPanel from "./components/NotificationRolesPanel.vue";
import { mapGetters } from "vuex";
export default {
  components: {
    ProSpaceCustomFilterPanel,
    ProSpaceMultiSelect,
    ProSpaceFilterPanel,
    ProSpaceInputText,
    ProSpaceGeoLayout,
    ProSpaceTableHeaderCell,
    ModalForm,
    ProSpaceMainGrid,
    Column,
    ProSpaceEmptyGrid,
    NotificationRolesPanel,
  },
  data() {
    return {
      // Grid Panel
      selectedModel: [],
      selectedValues: [],
      spKey: 0,
      spHide: false,
      emitter: event_bus,

      // Service
      roleService: new RoleService(),
      statusService: new StatusService(),

      // Common
      layoutName: "Roles",

      // Modal
      modalModel: {
        systemName: "",
      },
      isEdit: false,
      isCreate: false,

      // Filter Panel Model
      modelFastFilter: {
        label: this.$t("allTxt"),
        value: false,
        field: "disabled",
      },
    };
  },
  methods: {
    getStatus(status) {
      if (!status) return;
      let type = "default";
      switch (status.toLowerCase()) {
        case "complete":
          type = "success";
          break;
        case "process":
          type = "warning";
          break;
        case "error":
          type = "danger";
          break;
        default:
          type = "default";
      }
      return {
        text: status[0].toUpperCase() + status.toLowerCase().slice(1),
        type,
      };
    },
    customFilterApply(filter, model) {
      filter = Object.assign(filter, model);
      this.$refs["filter-panel"].submitFilter();
    },
    selectedHandler({items: val}) {
      if (!val) val = [];
      if (!Array.isArray(val)) {
        val = [val]
      }
      const id = val.map((i) => i.id);

      this.selectedModel = id;
      this.selectedValues = val;
      if (this.selectedModel.length == 0) {
        this.selectedModel = [];
      } else {
        this.spKey = id.join();
        this.masterId = id[0];
      }
    },
    submitFilter({ filter, search }) {
      this.$refs.grid.submitFilter(filter, search);
      this.clear()
    },
    spToggle() {
      this.spHide = !this.spHide;
    },
  },
  computed: {
    ...mapGetters({
      userinfo: "userinfoStore/getUserinfo",
    }),
    spShow() {
      return this.selectedModel.length > 0;
    },
    spVisible() {
      return this.selectedModel && this.selectedModel.length > 0;
    },
    disabledModalRule() {
      return this.modalModel.systemName.length == 0;
    },
    fastFilters() {
      return [
        {
          label: this.$t("allTxt"),
          value: false,
          field: "disabled",
        },
        { label: this.$t("active"), field: "isActive", value: true },
      ];
    },
    customServices() {
      return [
        {
          type: "number",
          model: "id",
          label: this.$t("id"),
          selected: {},
        },
        {
          type: "checkboxes",
          service: new StatusService(),
          getMethod: "get",
          model: "status",
          label: this.$t("status"),
          optionValue: "status",
          optionLabel: "text",
          selected: {},
        },
        {
          type: "chips",
          model: "createdBy",
          label: this.$t("createdByTxt"),
          selected: {},
        },
        {
          type: "chips",
          model: "updatedBy",
          label: this.$t("updatedByTxt"),
          selected: {},
        },
        {
          type: "dates-range",
          model: "createdAt",
          label: this.$t("createDate"),
          optionValue: "date",
          selected: {},
          dateFormat: this.userinfo.dateFormat,
        },
        {
          type: "dates-range",
          model: "lastUpdated",
          label: this.$t("lastUpdatedTxt"),
          optionValue: "date",
          selected: {},
          dateFormat: this.userinfo.dateFormat,
        },
      ];
    },
  },
};
</script>
